export enum JobType {
    Permanent = "Permanent",
    PartTime = "PartTime",
    Temporary = "Temporary",
    Contract = "Contract",
    Internship = "Internship",
    Volunteer = "Volunteer",
}